import Vue from 'vue'
import Router from 'vue-router'

import feds from '../pages/feds'
import hotkeywords from '../pages/hotkeywords'
import aceranking from '../pages/aceranking'
import nsfckeywords from '../pages/nsfckeywords'
import visit from '../pages/visit'
import detail from '../pages/nsfcdetail'
import demo from '../pages/nsfcdemo'
import geosciencekeywords from '../pages/geosciencekeywords'
import hotKeywordsMap from '../pages/hotKeywordsMap'
import mapDetails from '../pages/mapDetails'
import AbbrSearch from '../pages/AbbrSearch'
import AbbrHome from '../pages/AbbrHome'
import search from '../pages/Search'
import Trends from "../pages/Trends/index.vue"
import TrendsExplore from "../pages/Trends/explore.vue"
import nsfcSearch from "../pages/nsfcSearch/index.vue"
import nsfcSearchDetails from "../pages/nsfcSearch/details.vue"
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'home',
            component: () =>
                import ("@/pages/Home")
        },
        {
            path: '/feds',
            name: 'feds',
            component: feds
        },
        {
            path: '/hotkeywords',
            name: 'hotkeywords',
            component: hotkeywords
        },
        {
            path: '/topscholar',
            name: 'aceranking',
            component: aceranking
        },
        {
            path: '/nsfckeywords',
            name: 'nsfckeywords',
            component: nsfckeywords
        },
        {
            path: '/hotkeywords-map',
            name: 'hotKeywordsMap',
            component: hotKeywordsMap
        },
        {
            path: '/map-details',
            name: 'mapDetails',
            component: mapDetails
        },
        {
            path: '/detail',
            name: 'detail',
            component: detail
        },
        {
            path: '/visit',
            name: 'visit',
            component: visit
        },
        {
            path: '/demo',
            name: 'demo',
            component: demo
        },

        {
            path: '/geosciencekeywords',
            name: 'geosciencekeywords',
            component: geosciencekeywords
        },
        {
            path: '/search',
            name: 'search',
            component: search
        },
        {
            path: '/abbr-home',
            name: 'abbr-home',
            component: AbbrHome
        },
        {
            path: '/abbr-search',
            name: 'abbr-search',
            component: AbbrSearch
        },
        {
            path: '/trends',
            name: 'trends',
            component: Trends
        },
        {
            path: '/trends-explore',
            name: 'trends-explore',
            component: TrendsExplore
        },
        {
            path: '/nsfc-search',
            name: 'nsfc-search',
            component: nsfcSearch
        },
        {
            path: '/nsfc-s-details',
            name: 'nsfc-s-details',
            component: nsfcSearchDetails
        },
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js